import actions from './actions';
let currentUser = null;
let infoAvatar = null;

const storedCurrentUser = localStorage.getItem("currentUser");
if (storedCurrentUser && storedCurrentUser !== "undefined") {
  try {
    const _currentUser = JSON.parse(storedCurrentUser);
    currentUser = _currentUser.user ?? _currentUser;
    infoAvatar = currentUser.avatar;
  } catch (error) {
    console.error("Error parsing currentUser from localStorage:", error);
    localStorage.removeItem("currentUser");
  }
}
const initState = {
  infoAvatar
};

export default function profileReducer(state = initState, action) {
  switch (action.type) {
    case actions.SET_AVATAR:
      return {
        ...state,
        infoAvatar: action.infoAvatar
      };
    default:
      return state;
  }
}
